// input.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsInputTextareaComponent } from './input-textarea.component';
 

@NgModule({
  declarations: [AsInputTextareaComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule ],
  exports: [AsInputTextareaComponent]
})
export class AsInputTextareaModule {}
